module.exports = __webpack_public_path__ + "static/media/chevron-left.ef53cb85.svg";